export const getRiberaAltaData = () => ({
  name: "Ribera Alta",
  country: "Espagne",
  region: "Ribera del Duero",
  description: "Ribera Alta est une sous-région de la Ribera del Duero, produisant des vins rouges puissants et structurés avec le cépage Tempranillo.",
  type: "subregion",
  mapAreas: [
    { region: "Ribera Alta", x: 43, y: 33, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "8,000 ha",
    production: "300,000 hl",
    wineries: "80+ bodegas",
    villages: "15 villages",
    exportPercentage: "60%"
  },
  characteristics: {
    climate: "Climat continental tempéré, étés chauds, hivers froids",
    soil: "Sols calcaires et argilo-calcaires, galets roulés",
    viticulture: "Viticulture traditionnelle, rendements limités"
  },
  wineStyles: {
    red: "Rouges puissants et structurés, tanins fermes, grande capacité de garde"
  },
  history: "Ribera Alta produit des vins depuis l'époque romaine. La région est devenue célèbre avec Vega Sicilia au XIXe siècle.",
  foodPairing: "Viandes rouges, agneau, fromages affinés, cuisine castillane",
  grapeVarieties: [
    {
      name: "Tempranillo",
      percentage: "85%",
      description: "Cépage roi de Ribera del Duero, produisant des vins puissants et structurés",
      characteristics: "Puissant, structuré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Cabernet Sauvignon",
      percentage: "10%",
      description: "Cépage d'assemblage, apportant structure et complexité",
      characteristics: "Structuré, complexe, tanins fermes, notes de cassis",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Merlot",
      percentage: "3%",
      description: "Cépage d'assemblage, apportant rondeur et fruité",
      characteristics: "Fruité, rondeur, tanins doux, notes de fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Malbec",
      percentage: "2%",
      description: "Cépage d'assemblage, apportant couleur et structure",
      characteristics: "Coloré, structuré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    }
  ]
}); 